import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ConfirmationDialogService } from 'src/app/modules/confirmation-dialog/confirmation-dialog.service';
import { SettingsDialogService } from '../services/settings-dialog.service';
import { TankProfilesComponent } from '../tank-profiles/tank-profiles.component';
import { FilterProfilesComponent } from '../filter-profiles/filter-profiles.component';
import { IDirty } from '@interfaces/idirty.interface';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent {
  @ViewChild('tankProfiles') tankProfiles: TankProfilesComponent;
  @ViewChild('filterProfiles') filterProfiles: FilterProfilesComponent;

  //componentName is the @ViewChild property holding that section, read by checkDirty
  navigation: Array<{id: string, icon: string, name: string, shortName: string, componentName: 'tankProfiles' | 'filterProfiles'}> = [
    {
      id: '1',
      icon: 'table_chart',
      name: 'PageMenu.TankProfilesMenuText',
      shortName: 'Settings.TankTab',
      componentName: 'tankProfiles',
    },
    {
      id: '2',
      icon: 'filter_list',
      name: 'PageMenu.FilterProfilesMenuText',
      shortName: 'Settings.FilterTab',
      componentName: 'filterProfiles',
    },
  ];

  navigateTo = this.navigation[0].id;

  /** The dialog is always one kind of profile, so the title names it. */
  get currentSection() {
    return this.navigation.find(nav => nav.id === this.navigateTo) ?? this.navigation[0];
  }

  constructor(
    private readonly confirmationDialog: ConfirmationDialogService,
    private readonly settingsDialogService: SettingsDialogService,
    private readonly cdr: ChangeDetectorRef 
  ) {
  }

  onNavigateTo(navId: string, toggle?: MatButtonToggleGroup) {
    this.checkDirtyAndNavigate(navId, () => {
      if (toggle) toggle.value = this.navigateTo;
    });
  }

  close() {
    if (this.checkDirty(this.navigateTo)) {
      this.confirmationDialog.showModelIsDirtyDialog().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.settingsDialogService.close();
        }
      });
    } else {
      this.settingsDialogService.close();
    }
  }

  private checkDirty(navID: string): boolean {
    const navItem = this.navigation.find(item => item.id === navID);  
    if (!navItem) {
      return false;
    }
    const component = this[navItem.componentName];
    if (component && component.isDirty) {
      return component.isDirty();
    }
    return false;
  }


  checkDirtyAndNavigate(event: any, onCancelled?: () => void) {
    if (this.checkDirty(this.navigateTo)) {
      this.confirmationDialog.showModelIsDirtyDialog().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.navigateTo = event;
        } else {
          onCancelled?.();
        }
        this.cdr.markForCheck();
      });
    } else {
      this.navigateTo = event;
      this.cdr.markForCheck();
    }
  }

}

export interface SettingsNavigation {
  icon?: string;
  name: string;
  route: string;
}
